export const HEADER_TITLE = "HEADER_TITLE";
export const HEADER_BACK_BUTTON = "HEADER_BACK_BUTTON";



// WEBPACK FOOTER //
// ./src/actions/header/types.js